export const initialState = {
  sideMenuOpened: false,
  downMenuOpened: false,
};
